import { useNavDrawer } from 'components/navigation/nav_drawer';
import { FormattedMessage } from 'react-intl';
import { PartnerApi } from 'apis/PartnerApi';
import { Form } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { useApp } from 'app/context';

const MANAGE_TC_ID = -2;
const RESET_ID = -1;

export const PartnerSelect = props => {

    const [state, setState] = useSuperState({
        loading: false
    });
    const { loading } = state;

    const { launchPartnerLookupModal, selectedPartner, userPartners } = useApp();
    const { close } = useNavDrawer();

    const isManagingChild = selectedPartner && !userPartners.some(p => p.PartnerId === selectedPartner.id);

    const handleChange = async (value: string) => {

        const partnerId = parseInt(value, 10);
        if (isNaN(partnerId) || partnerId === selectedPartner?.id) return;

        // Close the mobile drawer on selection. Most branches reload the page (which
        // resets the drawer anyway), but "Manage a Testing Center" only opens the
        // partner lookup modal without reloading — without this the drawer stays open.
        close();

        setState({ loading: true });

        try {

            if (partnerId === RESET_ID) {

                await PartnerApi.ClearSelectedPartner();
                window.location.href = '/';
                return;

            }

            if (partnerId === MANAGE_TC_ID) {

                await launchPartnerLookupModal();
                setState({ loading: false });
                return;

            }

            await PartnerApi.SetSelectedPartner(partnerId);

            // Full reload to ensure all SSR state is consistent
            window.location.reload();

        } catch {

            setState({ loading: false });

        }

    };

    const options = isManagingChild
        ? [
            { id: selectedPartner.id, name: selectedPartner.name },
            { id: MANAGE_TC_ID, name: 'Manage another Partner' },
            { id: RESET_ID, name: 'Reset' }
        ]
        : [
            ...userPartners.map(p => ({ id: p.PartnerId, name: p.Name })),
            ...(selectedPartner?.type !== 4 ? [{ id: MANAGE_TC_ID, name: 'Manage a Partner' }] : [])
        ];

    return (
        <div className="partner-select d-flex flex-column gap-1 pb-4 pt-2">

            <label className="text-white small text-center">
                <FormattedMessage defaultMessage="Currently Managing" id="currently_managing.1eb4e043" />
            </label>

            <Form.Select
                className="w-100"
                disabled={loading}
                onChange={e => handleChange(e.target.value)}
                size="sm"
                value={selectedPartner?.id ?? ''}
            >
                {options.map(opt => (
                    <option key={opt.id} value={opt.id}>
                        {opt.name}
                    </option>
                ))}
            </Form.Select>
        </div>
    );

};
